//Generated File 
export default class FontSize{
	static readonly Large = `Large`;
	static readonly Medium = `Medium`;
	static readonly Small = `Small`;
	static readonly VeryLarge = `VeryLarge`;
	static readonly VerySmall = `VerySmall`;
}
